/**
 * Canonical turn mode normalizer.
 * Maps all string variants to a consistent underscore format.
 */
export type CanonicalTurnMode = "free_form" | "round_robin" | "initiative_order" | "concurrent";

const MODE_MAP: Record<string, CanonicalTurnMode> = {
  free: "free_form",
  free_form: "free_form",
  "free-form": "free_form",
  round_robin: "round_robin",
  "round-robin": "round_robin",
  initiative_order: "initiative_order",
  "initiative-order": "initiative_order",
  concurrent: "concurrent",
};

export function normalizeTurnMode(raw?: string | null): CanonicalTurnMode {
  if (!raw) return "free_form";
  return MODE_MAP[raw.toLowerCase().trim()] || "free_form";
}

export function isStructuredTurnMode(mode: CanonicalTurnMode): boolean {
  return mode === "round_robin" || mode === "initiative_order";
}
